import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const ProfilePage = lazy(() =>
  import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })),
)

const feature: FrontendFeature = {
  navItems: [],
  routes: [
    <Route
      key="profile"
      path="/profile"
      element={
        <ProtectedRoute>{lazyRoute(<ProfilePage />)}</ProtectedRoute>
      }
    />,
  ],
}

export default feature
